/** Rounds to 2 decimals — mandatory for stored chicken stats (AGENT.md §3). */
export function round2(value: number): number {
  return Math.round(value * 100) / 100;
}

export function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value;
}

/** Clamped to the 0–100 stat range and rounded in one step. */
export function clampStat(value: number): number {
  return round2(clamp(value, 0, 100));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}
